__turbopack_context__.v({
  "logo": "BrandLogo-module-scss-module___hiE0G__logo",
  "small": "BrandLogo-module-scss-module___hiE0G__small",
  "small-logo": "BrandLogo-module-scss-module___hiE0G__small-logo",
  "wrapper": "BrandLogo-module-scss-module___hiE0G__wrapper",
});
